import { RouteType } from "../../../types/RouteType";

const productCategoriesRoute: RouteType = {
    name: "Product Categories",
    path: "/product/categories/:categoryId?",
    defaultParams: {
        categoryId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./ProductCategories.Header"),
            title: "Product Categories",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./ProductCategories.Container"),
            grayBackground: false,
        },
    },
    group: 'Product',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const productCategoriesStore = rootStore.productCategoriesStore as any;
            if (productCategoriesStore && typeof productCategoriesStore.loadCategories === 'function') {
                await productCategoriesStore.loadCategories();
                if (params.categoryId && typeof productCategoriesStore.loadCategoryDetail === 'function') {
                    await productCategoriesStore.loadCategoryDetail(params.categoryId);
                }
            }
            return true;
        } catch (error) {
            console.error("Failed to load product categories:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.categoryId !== previousParams?.categoryId) {
            const productCategoriesStore = rootStore.productCategoriesStore as any;
            if (params.categoryId && productCategoriesStore && typeof productCategoriesStore.loadCategoryDetail === 'function') {
                await productCategoriesStore.loadCategoryDetail(params.categoryId);
            }
        }
    },
    dialogs: [
        // Dialogs would need to be created as separate files
        // For now, commenting them out to prevent missing import errors
    ],
};

export default productCategoriesRoute;
